<template>
    <div>
        <h1>Contact</h1>
        <p>Email: <a class="a" href="mailto:help@runningsons.com">help@runningsons.com</a></p>
    </div>
</template>

<script>
export default {
    name: "Contact"
}
</script>

<style scoped>
p {
    text-align: left;
}
</style>